/**
 * When a fixed scrollbar is shown (as in most browsers on Windows, and on macOS with the "always
 * show scrollbars" setting), `100vw` does not account for it width, ie. the scrollbar will sit
 * on top of an element with this width, covering its right edge.
 *
 * This function sets a CSS variable that can be used to fix this, like so:
 *
 * `width: 100vw - var(--scrollbar-width, 0px);`
 */
function updateScrollbarWidth() {
  const documentWidth = document.documentElement.clientWidth
  if (documentWidth <= 0) {
    return
  }

  let scrollBarWidth = 0

  let isAndroid = document.body.classList.contains("android")
  let isChrome145OrLater = false

  if (navigator?.userAgent) {
    const matches = navigator.userAgent.match(/Chrome\/([0-9]+)\./)
    if (matches && matches.length > 1 && parseInt(matches[1]) >= 145) {
      isChrome145OrLater = true
    }
  }

  // This issue doesn't show up on Android, and has also been "fixed" since Chrome 145
  // See https://www.bram.us/2026/01/15/100vw-horizontal-overflow-no-more/
  if (!isAndroid && !isChrome145OrLater) {
    scrollBarWidth = window.innerWidth - documentWidth
  }

  document.documentElement.style.setProperty(
    "--scrollbar-width",
    scrollBarWidth + "px",
  )
  document.documentElement.style.setProperty(
    "--half-scrollbar-width",
    scrollBarWidth / 2 + "px",
  )
}

window.addEventListener("resize", updateScrollbarWidth)
window.addEventListener("load", updateScrollbarWidth)
